import styles from "./shared.module.css"

import React from "react"
import createReactClass from "create-react-class"
import cx from "classnames"
import merge from "lodash/merge"
import assign from "object-assign"
import * as util from "activities/util"
import * as fonts from "shared/fonts"
import {ThemeContext} from "activities/context"
import {ClientContext} from "coach/context"
import Loading_ from "activities/components/shared/loading"
import {getSubdomain} from "coach/util/env"
import {getOrCreateVisitorId} from "util/visitor-id"

export const ColoredRangeGraph = ({percent, color}) => (
  <div className={styles["colored-range"]}>
    <div className={cx(styles["tooltip"], fonts.getFontClass())} style={{left: `${percent}%`}}>
      You
    </div>
    <div className={styles["indicator"]} style={{left: `${percent}%`, backgroundColor: `${color}`}}></div>
  </div>
)

export const Calculator = ({children, className}) => <div className={cx(styles["calculator"], className && className, "calculator")}>{children}</div>

export const Chart = ({children, className, ...props}) => (
  <div className={cx(styles["chart"], className && className)} {...props}>
    {children}
  </div>
)

export const Content = ({children, className}) => <div className={cx(styles["content"], className && className)}>{children}</div>

export const SummaryCalcContainer = ({children, className, ...props}) => (
  <div className={cx(styles["summary-calc-container"], styles["content"], className && className)} {...props}>
    {children}
  </div>
)
export const ChartContainer = ({children, className, ...props}) => (
  <div className={cx(styles["chart-container"], styles["chart"], className && className)} {...props}>
    {children}
  </div>
)
export const InputsContainer = ({children, className, ...props}) => (
  <div className={cx(styles["inputs-container"], styles["calculator"], className && className, "calculator")} {...props}>
    {children}
  </div>
)
export const SummaryContainer = ({children, className, ...props}) => (
  <div className={cx(styles["summary-container"], className && className)} {...props}>
    {children}
  </div>
)

// NOTE: empty title attribute prevents alt-text tooltips
export const Activity = ({children, className}) => (
  <div title="" className={cx(styles["activity"], className, "activity", fonts.getFontClass())}>
    <div className={styles["container"]}>{children}</div>
  </div>
)

export const SmallButton = ({children, onClick, label}) => (
  <button className={styles["button"]} onClick={onClick} aria-label={label}>
    {children}
  </button>
)

export const Loading = Loading_

export const Note = ({children}) => <div className={styles["note"]}>{children}</div>

// NOTE: selected hover styles only show when server styles are applied
export const Tab = ({option, onClick, selected, theme}) => (
  <button className={cx(styles["tab"], selected && styles["selected"], fonts.getFontClass())} onClick={onClick} key={option.title}>
    <div className={cx(styles["tab-title"], fonts.getFontClass())}>{option.tabTitle || option.title}</div>
    <div>{option.subtitle}</div>
  </button>
)

export const ActivityFactory = (ActivityImpl, setup = {}) => {
  const {defaultState = {}, defaultProps = {}, stateFilter = (state) => state} = setup
  const delay = 2500
  let throttler = null

  return class extends React.Component {
    static contextType = ClientContext

    constructor(props) {
      super(props)
      this.state = merge({}, defaultState, props.initialState, {resetKey: 0})
      this.onReset = this.onReset.bind(this)
      this.updateState = this.updateState.bind(this)
      this.getState = this.getState.bind(this)
      this.getProps = this.getProps.bind(this)
      this.doSetState = this.doSetState.bind(this)
      // Memoize visitor ID to prevent race conditions during rapid state updates
      this.visitorId = getOrCreateVisitorId()
    }

    componentDidUpdate() {
      clearTimeout(throttler)
      throttler = setTimeout(() => {
        const newState = assign({}, this.state)
        delete newState.resetKey
        const subdomain = getSubdomain()
        // Use memoized visitor ID to avoid race conditions
        this.context.post(`/api4/calculators/state${subdomain ? `?subdomain=${subdomain}` : ""}`, {
          calculator_id: this.props.activityId || "calculator",
          visitor_id: this.visitorId,
          state: stateFilter(newState)
        })
      }, delay)
    }

    onReset() {
      const {skipReset = []} = defaultProps
      let toSkip = {}
      if (skipReset.length > 0) {
        toSkip = assign(
          ...skipReset.map((key) => ({
            [key]: this.state[key]
          }))
        )
      }
      this.setState(
        merge({}, defaultState, this.props.initialState, toSkip, {
          resetKey: this.state.resetKey + 1
        })
      )
    }

    updateState(key, modifierFn) {
      return (value) => {
        const change = {}
        change[key] = (modifierFn || ((v) => v))(value)
        this.setState(change)
      }
    }

    getState() {
      return this.state
    }

    getProps() {
      const {theme} = this.props
      return merge({}, defaultProps, this.props, {
        theme: theme || util.defaultTheme,
        resettable: defaultProps.hasOwnProperty("resettable") ? defaultProps.resettable : true
      })
    }

    doSetState(directArgs) {
      this.setState(directArgs)
    }

    render() {
      const {className, title, subtitle, resettable, isWizardCalculator} = this.getProps()
      return (
        <div className={styles["container-type"]}>
          <Activity className={cx(resettable && "resettable", className)}>
            {resettable && (
              <button aria-label="Reset to default values." className={styles["reset"]} onClick={this.onReset}>
                <i className={cx(styles["bz"], styles["bz-reset-arrow"])}></i>
              </button>
            )}
            {title && !isWizardCalculator && <h2 className={cx(styles["title"], fonts.getFontClass())}>{title}</h2>}
            <div className={cx(styles["subtitle"], fonts.getFontClass())}>{subtitle}</div>
            <ActivityImpl
              {...merge({
                updateState: this.updateState,
                getState: this.getState,
                getProps: this.getProps,
                setState: this.doSetState,
                onReset: this.onReset
              })}
            />
          </Activity>
        </div>
      )
    }
  }
}

const textColor = (theme, diff) => (diff > 0 ? theme["color-4"] : diff < 0 ? theme["color-1"] : "A7AAB1")

export const DifferenceRow = ({title, difference}) => (
  <ThemeContext.Consumer>
    {(theme) => (
      <tr className={styles["difference-row"]}>
        <td className={cx(styles["row-title"], fonts.getFontClass())}>{title}</td>
        <td className={cx(styles["difference"], fonts.getFontClass())}>
          {(difference && `${util.formatPercent(Math.abs(difference))} ${difference > 0 ? "More" : "Less"}`) || "No Change"}
        </td>
      </tr>
    )}
  </ThemeContext.Consumer>
)
